import type { ZoneRow } from './zoneUsbDacRemap';
import { hydrateGhostUsbDacZone } from './zoneRestoreGhostHydrate';
import { findPreferredZone } from './zoneRestorePreferred';
import { LOCAL_ZONE_STORAGE_ID } from '../utils/localZoneStorage';
import { readSavedZoneMeta } from './zoneRestorePick';

function isLocalZone(zone: ZoneRow): boolean {
  return zone.type === 'browser' || zone.type === 'local'
    || zone.id === LOCAL_ZONE_STORAGE_ID
    || zone.id === 'this_computer'
    || zone.id === 'this_device';
}

export function findLiveZoneForSaved(savedId: string, zones: ZoneRow[]): ZoneRow | null {
  const ghostUsb = hydrateGhostUsbDacZone(savedId, zones);
  if (ghostUsb) return ghostUsb;
  const byId = findPreferredZone(savedId, zones);
  if (byId) return byId;
  const meta = readSavedZoneMeta();
  if (!meta || meta.id !== savedId) return null;
  const nameKey = String(meta.name || '').trim().toLowerCase();
  if (!nameKey) return null;
  const byName = zones.filter(
    (z) => String(z.name || '').trim().toLowerCase() === nameKey && !isLocalZone(z),
  );
  return byName.length === 1 ? byName[0] : null;
}
